document.addEventListener('DOMContentLoaded', function() {
  // Check if the current page is /pages/heroes
  if (window.location.pathname === '/pages/heroes' || window.location.pathname === '/pages/heroes/') {
    const endpoint = 'https://api-prod.dansonscorp.com/api/v1/heroes';

    fetch(endpoint)
      .then(response => response.json())
      .then(data => {
        // Make sure to adjust according to the actual data structure
        // Assuming 'data' contains an array under 'heroes' key and we're interested in the first item
        console.log('data', data)
        const hero = data.data.heroes[0]; // This line might need adjustment based on the actual API response structure

        const heroHtml = `
          <div class="border border-image p-4">
            <div class="mt-1 mb-4 ml-3 mr-3 border-bottom border-muted"></div>
            <div class="row mt-3 ml-1 mr-1 mb-3">
              <div class="col-lg-7 col-xl-7">
                <img
                  alt="Hero"
                  src="${hero.image_url}"
                  class="border border-dark p-2"
                  style="display: block; margin-left: auto; margin-right: auto;"
                />
              </div>
              <div class="col mt-3">
                <img
                  alt="logo"
                  src="https://dansons-site-images.s3.us-west-2.amazonaws.com/dansons/revamped-heros/hero-image-update-v3.png"
                  style="display: block; margin-left: auto; margin-right: auto;"
                />
              </div>
            </div>
            <div class="pl-3 pr-3">
              <h2>${hero.first_name} ${hero.last_name}</h2>
              <p>
              Join us in recognizing our Pit Boss Hero of the Month, ${hero.first_name} ${hero.last_name}
               <a
  class="plain-link"
  href="https://pitboss-grills.ca/pages/heroes/${hero.first_name.toLowerCase()}-${hero.last_name.toLowerCase()}"
  >Read More</a
>
              </p>
            </div>
            <div class="mt-4 mb-2 ml-3 mr-3 border-top border-muted">
              <p class="pt-3">
                <a class="plain-link" href="https://pitboss-grills.ca/pages/about-pitboss-heros"
                  >Pit Boss Heroes</a
                >
              </p>
            </div>
          </div>
        `;

        // Inject the content into a div with id 'hero-display-container'
        const container = document.getElementById('hero-display-container');
        if (container) {
          container.innerHTML = heroHtml;
        }
      })
      .catch(error => {
        console.error('Error fetching hero data:', error);
      });
  }
});
